module.exports = __webpack_public_path__ + "img/Arma 3 Unit Newfound Pioneer Corps Events.2e700a42.webp";